export default "__VITE_ASSET__Cd2kQLx$__"